import { all } from 'redux-saga/effects';
import summary from 'sagas/dashboard/driveoff/summary';

export default function* location() {
  yield all([summary()]);
}
